/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import CTAs from 'components/shared/ctas/ctas';
import Button from 'components/shared/button/button';
import Title from 'components/shared/title/title';
import BodyCopy from 'components/shared/bodycopy/bodycopy';
import ProgressBar from 'components/shared/progressbar/progressbar';
// STYLES
import styles from 'components/content/userdatacollection/phases/udcsuccess/udcsuccess_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, { link:false });



/* ========== ~~~~~~~~~~ SER DATA COLLECTION SUCCESS PHASE: CHILD ~~~~~~~~~~ ========== */
class UDCSuccessPhase extends Component {
    constructor(props) {
        super(props);
        this.timeoutId = null;
        this.state = { loaded: false };
    }
    handleNext = () => {
        clearTimeout(this.timeoutId);
        this.props.advanceFrame(this.props.contentId);
    };
    componentDidMount() {
        this.completeSuccessPhase();
        this.setState({ loaded: true })
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId)
    }
    completeSuccessPhase = () => {
        const timeoutTime = !!this.props.showFrameForXSeconds ? this.props.showFrameForXSeconds: 5000;
        this.timeoutId = setTimeout(() => {
            this.handleNext()
        }, timeoutTime);
    };
    render() {
        return (
            <div className={`${sheet.classes.udcsuccess} uniquecontent ${this.props.phase}`}>
                <ProgressBar type={`result`} duration={!!this.props.showFrameForXSeconds ? this.props.showFrameForXSeconds: 5000} fillingDelay={null} direction={`leftToRight`} isActive={this.state.loaded} shouldKillItself={false}/>
                <div className={`successmessage`}>
                    <div className={`graphic success`} />
                    <Title>{`Success!`}</Title>
                    <BodyCopy>
                        <p>{`Thank you for submitting your email address`}</p>
                    </BodyCopy>
                </div>
                <CTAs type={`inline`}>
                    <Button klass={`white`} onClick={this.handleNext}>{`Next`}</Button>
                </CTAs>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default UDCSuccessPhase;
